export default class Language {
    static fromData(data) {
        if (!data) {
            return;
        }

        const language = new Language();
        language.code = data.code;
        language.name = data.name;

        Object.seal(language);
        return language;
    }
}
